import { keyframes } from '@emotion/react';
import { Body, BodyProps, useChakraTheme } from '@hover/blueprint';
import { forwardRef } from '@hover/blueprint/chakra';
import React from 'react';

interface AnimatedTextProps extends BodyProps {
  animationStep: number;
}

const STEP_MULTIPLIER = 1.15;

const getAnimationString = (spacing: string) =>
  keyframes`
  0% {
    opacity: 0;
    transform: translateY(${spacing});
  }
  50% {
    opacity: 1;
    transform: translateY(0);
  }
  80% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(${spacing});
  }`.toString();

const AnimatedText = forwardRef<AnimatedTextProps, 'p'>(
  ({ animationStep, ...props }, ref) => {
    const theme = useChakraTheme();
    const textTranslationValue = theme.space[800];

    return (
      <Body
        opacity={0}
        position="absolute"
        sx={{
          animationFillMode: 'forwards',
          animationName: getAnimationString(textTranslationValue),
          animationDuration: '1.15s',
          animationDelay: `${(animationStep - 1) * STEP_MULTIPLIER}s`,
        }}
        transform={`translateY(${textTranslationValue})`}
        {...props}
        ref={ref}
      />
    );
  },
);

export { AnimatedText };
